import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

function Loading() {
  return (
    <div className="flex min-h-screen items-center justify-center" data-testid="auth-loading">
      <span className="font-display text-lg font-semibold tracking-[0.18em] text-muted-foreground">MIA</span>
    </div>
  );
}

export function ProtectedRoute() {
  const { user } = useAuth();
  const location = useLocation();
  if (user === undefined) return <Loading />;
  if (!user) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  return <Outlet />;
}

export function AdminRoute() {
  const { user } = useAuth();
  if (user === undefined) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return <Outlet />;
}
